const { constants } =  require('./constants');

const urls = {


  /**
   * get the frontend URL
   * 
   * @deprecated since moving to gatsby cloud
   */
  frontend: () => {
    if(process.env.CONTEXT === 'branch-deploy') {
      return process.env.DEPLOY_PRIME_URL;
    }
    else if(process.env.CONTEXT === 'deploy-preview') {
      return process.env.DEPLOY_URL;
    }
    else if(process.env.CONTEXT === 'production') {
      return process.env.URL;
    }
    else {
      return 'http://localhost:8000';
    }
  },


  /**
   * get the WordPress URL
   * 
   */
  wordpress: () => {

    if(process.env.WP_CUSTOM) {
      return constants.WP_CUSTOM;
    }

    const shouldPullFromProd =  process.env.HEAD    === "production" ||
                              ( process.env.HEAD    === "staging" &&
                                process.env.CONTEXT === 'deploy-preview' );

    if(shouldPullFromProd) {
      return constants.WP_PROD;
    }

    return constants.WP_STAGING;
  }

};

exports.urls = urls;